import { formatTimeToShow } from '@op/utils/time';
import { useIntl } from 'umi';
import React, { useMemo, useRef } from 'react';
import { formatChartParamsDate } from '@op/components/ChartCommon/formatter';
import { getPercentageInfo, mathFormat } from '@op/utils';
import { reviewsFormat } from '@op/utils/value';
import EChartCommon from '@op/components/EChartCommon';
import { TableColorType } from '@op/hooks/useTableSelect';

export default function PieCharts({
  filter,
  data,
  transHeroInfo,
  selectedKeysMap,
}: {
  filter: any;
  data: any;
  transHeroInfo: (key: string) => { icon: string; name: string };
  selectedKeysMap: TableColorType;
}) {
  const { formatMessage } = useIntl();
  const eChartsRef = useRef(null as any);

  const [options, total] = useMemo(() => {
    const { data: pieData, total: pieTotalData } = data || {};
    const total = pieTotalData || 0;
    const pieDataList = (pieData || []).map((item: any) => ({
      ...item,
      value: item.count,
    }));
    const options = {
      tooltip: {
        className: 'dbo-mentions-sentiment-box-tooltip-wrapper',
        enterable: true,
        formatter: (params: any) => {
          return formatChartParamsDate({
            title: formatTimeToShow(filter),
            params,
            listTitleFunc: (item) => {
              // const { name, icon } = transHeroInfo(item.name);
              return item.name;
            },
            valueFormat: (value) => {
              const percent = getPercentageInfo(params?.value, total, 2);
              return `${isNaN(value) ? '-' : reviewsFormat(value)}(${percent})`;
            },
            // textShowFun: textShowFun(formatMessage),
          });
        },
      },
      title: [
        {
          text: `{name|${mathFormat(total)}}`,
          top: '43%',
          left: 'center',
          textStyle: {
            rich: {
              name: {
                fontSize: 24,
                fontFamily: 'num-m',
                color: '#000000',
                padding: [10, 0],
              },
            },
          },
        },
      ],
      series: [
        {
          data: pieDataList.map((item: any) => {
            const info = transHeroInfo(item.name);
            const color = selectedKeysMap[item.name]?.color || item.color;
            return {
              ...item,
              ...info,
              itemStyle: { color },
            };
          }),
        },
      ],
      legend: {
        data: pieDataList.map((item: { name: any; color: any }) => {
          const { name } = transHeroInfo(item.name);
          const color = selectedKeysMap[item.name]?.color || item.color;
          return {
            name: name,
            itemStyle: { color },
          };
        }),
      },
    };

    return [options, total];
  }, [filter, data, formatMessage]);

  return (
    <EChartCommon
      optionsProps={{ type: 'pie', pieLabelAlignTo: 'edge', pieTotal: total }}
      height={310}
      options={options}
      ref={eChartsRef}
    ></EChartCommon>
  );
}
